const calendar = {
	title: "Calendar",
	new_task: "New Task",
	new_driving_test: "New Driving Test",
	new_course: "New Course",
	show_task: "Show Task",
	show_drivingtest: "Show Driving Test",
	show_course: "Show Course",
	instructor: "Instructor",
	not_assigned: "Not Assigned",
	filter_ctgroup: "Select course type group",
};
export default calendar;